export default {
	termsAndConditions: {
		lastUpdate: 'עודכן לאחרונה: 10 ביוני 2024',
		content: `
    <p>התנאים שתמצאו להלן חשובים מכיוון ש:</p>
    <ul>
        <li>הם מבססים את זכויותיכם המשפטיות ב-{siteName}.</li>
        <li>מסבירים את הזכויות שאתם מעניקים לנו כאשר אתם משתמשים ב-{siteName}.</li>
        <li>הם מתארים את הכללים שכולם חייבים לכבד בעת השימוש ב-{siteName}.</li>
    </ul>
    <p>
        אנא קראו תנאים אלה בעיון, כמו גם את {privacyPolicyLink} וכל מסמך אחר
        המוזכר בתנאים אלה.
    </p>
    <p>בואו נתחיל...</p>
    <h3>1. מבוא ונתוני {siteNameUpper}</h3>
    <p>
        האתר {websiteLink} (להלן: "האתר") הוא בבעלות חברת
        {siteName} S.L (להלן: "{siteName}"), חברה
        שהתאגדה בהתאם לחוק הספרדי וכתובתה ב-Avenida de
        Cerdanyola, מס' 75, קומה 1, סנט קוגט דל ואייס (ברצלונה), בעלת מספר CIF
        B-56.768.260 ורשומה במרשם המסחרי של ברצלונה בכרך
        49065, דף 0033, גיליון B-606324, רישום ראשון.
    </p>
    <p>
        {siteName} מעמידה לרשותכם את האתר כדי שתוכלו להכיר אותנו טוב יותר,
        להכיר את השירותים שאנו מספקים ואם תרצו, תוכלו ליצור קשר
        ובמקרה המתאים, להתקשר איתנו.
    </p>
    <h3>2. מטרה והיקף יישום של תנאי השימוש</h3>
    <p>
        תנאי שימוש אלה מהווים, יחד עם {privacyPolicyLink} ו-
        {cookiesPolicyLink}, את המסגרת המשפטית המסדירה את השימוש באתר
        {websiteLink}. תנאי שימוש אלה יהיו זמינים עבורכם באתר
        בעברית כך שתוכלו לעיין בהם, לשמור אותם או להדפיס אותם בכל עת
        ובכל זמן שתרצו.
    </p>
    <p>
        לכל שאלה בנוגע לטיפול שמבצעת {siteName} במידע האישי שלכם,
        אנא בקרו ב-{privacyPolicyLink} וב-{cookiesPolicyLink} שלנו.
        שתי המדיניויות יהיו זמינות עבורכם בעברית כך שתוכלו
        לעיין בהן, לשמור אותן או להדפיס אותן בכל עת.<br />
        {siteName} משתמשת בעוגיות צד שלישי באתר. למידע נוסף
        על סוגי העוגיות המשמשות באתר {websiteLink}, מטרתן ואופן
        הגדרת הדפדפן שלכם במקרה שאינכם מעוניינים שנשתמש בעוגיות אלה,
        אנא בקרו ב-{cookiesPolicyLink} שלנו.
    </p>
    <p>
        תנאי שימוש אלה, כמו גם {privacyPolicyLink} ו-{cookiesPolicyLink}
        הוכנו בהתאם להוראות התקנות החלות הנוכחיות, בין היתר, חוק 34/2002
        בדבר שירותי חברת המידע ומסחר אלקטרוני ותקנה (EU) 2016/679
        של הפרלמנט האירופי והמועצה מיום 27 באפריל 2016, בנוגע להגנה
        על אנשים טבעיים בכל הנוגע לעיבוד נתונים אישיים ולתנועה החופשית
        של נתונים אלה ואשר על פיה מבוטלת הנחיה CE/95/46.
    </p>
    <h3>3. גישה לאתר וקבלת תנאים</h3>
    <p>
        הגישה לאתר היא חינמית למעט העלות הכרוכה בחיבור דרך
        רשת התקשורת המסופקת על ידי ספק הגישה לאינטרנט שלכם.
        אתם יכולים לגלוש באתר באופן חופשי ולגשת אליו כמה פעמים שתרצו.
        כדי לגשת ולגלוש באתר, אינכם צריכים להירשם, למעט אם ברצונכם
        להזמין שירות.
    </p>
    <p>
        השימוש באתר מעניק לכם את מעמד המשתמש באתר
        (להלן: "המשתמש") ומשמעותו קבלה מלאה וללא סייג של
        תנאי שימוש אלה, כמו גם של {privacyPolicyLink} ו-{cookiesPolicyLink}
        של האתר. בנוסף, אתם מסכימים שלא להשתמש בשירות למטרות בלתי חוקיות.
    </p>
    <p>
        בגישה לאתר ובגלישה בו, אתם מצהירים באחריותכם כי אתם בגיל החוקי
        ובעלי הכשרות המשפטית הנדרשת לגישה לאתר ולשימוש בו, ומצהירים
        גם כי אתם מבינים ומקבלים באופן מלא את תנאי השימוש הללו ללא סייג.
    </p>
    <p>
        מצד שני, אנו מודיעים לכם כי מסיבות משפטיות אנו שומרים את
        המסמכים האלקטרוניים שבהם מתבצעות הרכישות. תוכלו לגשת
        למסמכים אלה בכל עת על ידי בקשה בכתובת: {supportLink}.
    </p>
    <h3>4. תנאי שימוש באתר</h3>
    <p>
        המשתמש מסכים להשתמש באתר בהתאם לתנאי שימוש אלה,
        החקיקה הנוכחית ותום הלב. כך, המשתמש יהיה אחראי כלפי {siteName}
        וכלפי כל צד שלישי בגין הנזקים והאובדן הנובעים
        משימוש המנוגד לתנאים אלה, לחקיקה ולתום הלב שנעשה
        על ידי המשתמש באתר.
    </p>
    <h3>5. תיאור השירות</h3>
    <p>
        באמצעות השירות, {siteName} מאפשרת מנוי לשירות
        לביצוע עריכת תמונות.
    </p>
    <p>
        השפה שבה ייחתם החוזה בין {siteName} לבין הקונה
        תהיה זו של ארץ המוצא.<br />
        תהליך הרכישה בשירות המקוון יהיה כדלקמן:
    </p>
    <ol>
        <li>עליכם להירשם באתר עם שם משתמש וסיסמה.</li>
        <li>
            בעת ההרשמה, על המשתמש לבחור באחת מתוכניות התשלום
            הנמצאות בסעיף המחירים ויוענקו לו נקודות זכות בהתאם לתוכנית
            שנבחרה. כל נקודת זכות תאפשר לכם לערוך תמונה אחת.
        </li>
        <li>
            לאחר רכישת השירות, למשתמש יהיה פאנל ניהול שבו ימצא:
            <ul>
                <li>
                    מדור עם רשימה של כל התמונות שעובדו, עם אפשרות
                    לערוך אותן כמה פעמים שתרצו ולהוריד אותן למכשיר שלכם.
                </li>
                <li>
                    מדור תוכניות ותשלומים לעיון בחשבוניות ולביטול המנוי.
                </li>
                <li>מדור החשבון שלי לשינוי העדפות החשבון.</li>
            </ul>
        </li>
    </ol>
    <p>
        לאחר ביצוע רכישת השירות, היא תאושר על ידי שליחת דוא"ל,
        תוך 24 שעות לכל היותר, לכתובת שציינתם. יצוין השירות,
        כיצד לבטל את המנוי, סכומו, המיסים החלים, צורת התשלום
        והתנאים וההגבלות החלים.
    </p>
    <h4>5.1 מנוי</h4>
    <p>
        מנוי השירות משתנה בהתאם לתוכנית שנבחרה ויתחדש אוטומטית
        לאותה תקופת זמן עד לסיומו. אלא אם תבטלו את המנוי שלכם,
        אתם מאשרים לנו לחייב את דמי המנוי השנתי המתאימים באמצעי
        התשלום שלכם.
    </p>
    <p>
        אתם יכולים לבטל את המנוי שלכם לשירות בכל עת, ותמשיכו
        לקבל גישה אליו עד לסוף תקופת החיוב השנתית שלכם. במידה
        המותרת על פי חוק, התשלומים אינם ניתנים להחזר ואיננו מספקים
        החזרים או זיכויים עבור תקופות מנוי שנתיות חלקיות.
    </p>
    <h3>6. מחיר ומיסים</h3>
    <p>
        מחירי המוצרים המוצעים ב-{siteName} מצוינים באירו
        (€) או במטבע של המדינה שממנה מתבצעת הרכישה, מס ערך
        מוסף (מע"מ) בתוקף בעת הרכישה מוטל על מחיר המוצרים.
    </p>
    <p>
        בכל מקרה, העסקה עשויה להיות פטורה או לא כפופה למע"מ
        בהתאם למדינת המגורים שלכם או לתנאי שבו אתם פועלים.
        מסיבה זו, במקרים מסוימים המחיר הסופי של ההזמנה עשוי
        להשתנות ביחס למוצג.<br />
        רכישות שנעשו על ידי נושאים הפטורים מתשלום מע"מ יציינו
        זאת על ידי שליחת מספר העוסק/מע"מ שלהם בדוא"ל ל-{supportLink},
        ולא יירשמו רכישות עם המס האמור.
    </p>
    <h3>7. אמצעי תשלום</h3>
    <p>
        תשלום מקוון עבור השירות שנרכש יכול להתבצע באמצעות
        כרטיס אשראי או חיוב. בהקשר זה, {siteName} מודיעה
        למחזיקי כרטיסי אשראי וחיוב כי העסקאות בחנות המקוונת
        מתבצעות באמצעות שער תשלום מאובטח, המשתמש בטכנולוגיית
        SSL להבטחת אבטחת העברת הנתונים.
    </p>
    <h3>8. זכות ביטול והחזרים</h3>
    <h4>8.1. זכות ביטול</h4>
    <p>
        בהתחשב בסוג המוצר המשווק בשירות המקוון שלנו, תוכנה בפורמט
        דיגיטלי של QR, זכות הביטול לא תהיה ישימה בהתאם
        לסעיף 103, אות m) של צו חקיקה מלכותי 1/2007, מיום 16 בנובמבר,
        שבו מאושר הנוסח המתוקן של החוק הכללי להגנת הצרכנים
        והמשתמשים וחוקים משלימים אחרים.
    </p>
    <h4>8.2. החזרים</h4>
    <p>
        ללא קשר לתוכנית שנבחרה על ידי המשתמש, הסכומים ששולמו
        על ידי המשתמש ובמידה המותרת על פי חוק לא יהיו ניתנים להחזר.
    </p>
    <p>
        לא ניתן להמחות או להעביר את השירות שנרכש למשתמשים
        אחרים של השירות.
    </p>
    <p>
        בכל מקרה, המשתמש יוכל להשתמש בשירות שנרכש עד לסוף
        התקופה שנרכשה.
    </p>
    <h3>9. תוקף ההצעות</h3>
    <p>
        השירותים המוצעים בשירות, ומחיריהם, יהיו זמינים לרכישה
        כל עוד הם בקטלוג השירותים המוצג באמצעות אתר זה.
    </p>
    <p>
        בכל מקרה, {siteName} שומרת לעצמה את הזכות לבצע את
        השינויים שהיא רואה לנכון בשירות, ויכולה לעדכן מוצרים
        ושירותים בהתאם לשוק.
    </p>
    <p>
        {siteName} שומרת לעצמה את הזכות לשנות מחירים ללא הודעה
        מוקדמת. אנו מודיעים לכם כי למרות העדכונים שנעשים במחירי
        השירות, הם עלולים להכיל שגיאות. נתקן במהירות כל שגיאה
        שתופיע, אך הן לא יהיו מחייבות את השירות.
    </p>
    <h3>10. אבטחה</h3>
    <p>
        כפי שצוין לעיל, כל תהליך הרכישה, כמו גם העברת הנתונים
        האישיים שלכם ומערכות התשלום, מתבצע בדף מאובטח ובצורה
        מוצפנת באמצעות פרוטוקול SSL.
    </p>
    <p>
        אנו מבטיחים את אבטחת השירות בהתאם לידע הטכנולוגי הנוכחי.
        עם זאת, {siteName} אינה יכולה להבטיח את האבטחה המלאה
        העתידית של השירות. בכל מקרה, אנו מבטיחים לתקן וליישם
        את האמצעים המתקנים המתאימים לתיקון פרצת אבטחה אפשרית
        בהקדם האפשרי.
    </p>
    <p>
        אתם מסכימים להודיע ל-{siteName}, מיד ובאמצעות דוא"ל {supportLink}
        על כל מצב שעלול להוביל להתחזות לזהות משתמש.
    </p>
    <h3>11. שינויים ובטלות</h3>
    <p>
        אנו עשויים לעדכן את התנאים וההגבלות של השירות בעתיד,
        כמו גם את התכונות והפונקציות של השירות עצמו.
    </p>
    <p>
        נודיע לכם על השינויים בתנאים ובהגבלות על ידי הצבת הודעה
        במקום בולט באתר שלנו ו/או באמצעות דוא"ל.
    </p>
    <p>
        אם סעיף כלשהו הכלול בתנאים ובהגבלות אלה מוכרז, באופן
        מלא או חלקי, כבטל או לא יעיל, הוא ישפיע רק על אותה הוראה
        או על החלק ממנה שהוא בטל או לא יעיל. התנאים וההגבלות
        יישארו בתוקף בכל שאר ההיבטים, כאשר הוראה כזו, או החלק
        ממנה שמושפע, נחשבת כאילו לא הוצבה.
    </p>
    <h3>12. תביעות ופעולות הנובעות מהחוזה</h3>
    <p>
        ככל האפשר, שירות זה מוסדר על פי החוק הספרדי.<br />
        כדי לפשט את פתרון התביעות באמצעות הליכים אזרחיים ולהפחית
        עלויות, איננו שוללים את האפשרות להגיש את עצמנו לבוררות
        הוגנת של בית הדין לבוררות של לשכות המסחר והתעשייה.
        בהקשר זה, ובהתאם לתקנות החלות, {siteName} מודיעה
        על קיומה של פלטפורמה מקוונת אירופית ליישוב סכסוכים
        המקלה על יישוב חוץ-משפטי של סכסוכים כאלה עבור חוזים
        שנחתמו גם הם באופן מקוון בין צרכנים לספקי שירותי אינטרנט.
        ניתן לגשת לפלטפורמה זו דרך האתר הבא:
        <a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>
    </p>
    <h3>13. זכויות קניין רוחני ותעשייתי</h3>
    <p>
        האתר ותכניו כפופים להגנה ביישום התקנות הלאומיות הנוכחיות
        בנושא קניין רוחני ו/או תעשייתי, כמו גם ביישום האמנות
        הבינלאומיות החלות בנושאים אלה. {siteName} היא הבעלים
        או בעלת רישיון כדין של כל זכויות הקניין הרוחני והתעשייתי
        על האתר ותכניו.
    </p>
    <p>
        כל צורה של שכפול, הפצה, תקשורת ציבורית, שינוי, הנגשה
        ובאופן כללי, כל פעולת ניצול אחרת בין אם למטרות מסחריות
        ובין אם לאו של האתר או תכניו, ללא הסכמה מפורשת מראש
        של {siteName}. חל איסור מפורש למחוק את נתוני הזיהוי
        של {siteName} כבעלת זכויות הקניין הרוחני והתעשייתי
        של האתר או תכניו.
    </p>
    <p>
        {siteName} שומרת על כל זכויות הקניין הרוחני והתעשייתי
        על האתר ותכניו, ושומרת גם על מימוש כל פעולה משפטית
        המתאימה לה כדי להפסיק, למנוע או לתבוע כל שימוש בלתי
        חוקי באתר או בתכניו. בשום מקרה ותחת שום נסיבות אין
        בגישה לאתר או בשימוש בו על ידי המשתמש או צדדים שלישיים
        משום הענקה או משתמע ממנה הענקה מכל סוג שהוא על ידי
        {siteName} של זכויות הקניין הרוחני או התעשייתי של האתר
        או תכניו. בשום מקרה לא ניתן להבין את חוסר הדרישה מצד
        {siteName} להפסיק שימוש באתר או בתכניו הבלתי חוקיים
        או המנוגדים לתנאים אלה כהסכמה שבשתיקה מצד {siteName}
        לשימושים כאלה או כוויתור על מימוש כל פעולה משפטית
        שעשויה להתאים לה.
    </p>
    <h3>14. אחריות וערבויות</h3>
    <p>
        המשתמש חייב להשתמש באתר ובתכניו בהתאם להוראות תנאי
        שימוש אלה, החקיקה הנוכחית ותום הלב. כל שימוש באתר
        או בתכניו המנוגד לתנאים כלליים אלה, לחוק או לתום הלב
        אסור במפורש, ללא קשר אם לשימוש זה יש מטרה כלכלית או לא.<br />
        המשתמש יהיה אחראי לכל נזק או פגיעה שייגרמו ל-{siteName}
        או לצדדים שלישיים הנובעים במישרין או בעקיפין מכל שימוש
        שהמשתמש עושה באתר או בתכניו המנוגד לתנאים אלה, לחוק,
        למוסר, לסדר הציבורי או לתום הלב.
    </p>
    <p>
        כדי שהאתר ותכניו יהיו נגישים למשתמש, {siteName} דורשת
        שירותים המסופקים על ידי צדדים שלישיים. ייתכן שלמרות
        המאמצים שנעשו על ידי {siteName} לשמור על האתר זמין
        ונגיש למשתמשים, זמינותו עלולה להיות מושעית, מופרעת
        או מבוטלת מסיבות שמעבר ל-{siteName}. לכן {siteName}
        אינה מבטיחה היעדר הפרעות או שגיאות בגישה לאתר או לתכניו,
        ולא שהם מעודכנים או מוצגים תמיד בגרסתם האחרונה. בהתאם
        לכך, {siteName} דוחה כל אחריות לנזקים שעלולים להיגרם
        למשתמש או לצדדים שלישיים כתוצאה מהשעיה, הפרעה, חוסר
        המשכיות, הפסקת רשת או ניתוק מהאתר.
    </p>
    <p>
        בשום מקרה ותחת שום נסיבות לא תהיה {siteName} אחראית
        לנזקים או אובדן שנגרמו למשתמש מסיבות שאינן ניתנות לייחוס
        ל-{siteName} כגון, כדוגמה ובשום מקרה לא מגבילה, אסונות
        טבע, מצבי כוח עליון או דחיפות קיצונית, וירוסים, רכיבים
        מזיקים, תקלות בדפדפן, נפילות רשת, חדירות מחשב או התקפות
        של צדדים שלישיים.
    </p>
    <h3>15. קישורים</h3>
    <p>
        אתרי אינטרנט, פלטפורמות, פורומים, צ'אטים, בלוגים או רשתות חברתיות חיצוניות
        המקשרות לאתר חייבות להודיע בבירור שאין להן את האישור או הפיקוח
        של {siteName} ושקישור זה אינו מהווה, מניח או מרמז על קשר מכל סוג
        בין {siteName} לבין אתרי האינטרנט, הפלטפורמות, הפורומים, הצ'אטים,
        הבלוגים או הרשתות החברתיות החיצוניות המקשרות לאתר.
    </p>
    <p>
        בכל מקרה, כל קישור המיועד לאתר חייב להיות מופנה ישירות לדף הבית
        של האתר על ידי לחיצה על כתובת ה-URL של האתר המכסה את המסך כולו
        של דף הבית או דף הפתיחה של האתר, כך שהקישור יהיה מוחלט ושלם
        ללא שימוש במסגרות או היפר-קישורים. {siteName} אינה אחראית בשום
        מקרה ותחת שום נסיבות לתוכן, למידע או לנתונים הקשורים לאתר,
        לתכניו או לכל עניין אחר הכלול באתרי אינטרנט, פלטפורמות, פורומים,
        צ'אטים, בלוגים או רשתות חברתיות של צד שלישי המקשרים לאתר.
    </p>
    <p>
        חל איסור מפורש לקשר לאתר מאתרי אינטרנט, פלטפורמות, פורומים,
        צ'אטים, בלוגים או רשתות חברתיות המנוגדים לחוק, למוסר ולמנהגים
        הטובים, במיוחד אלה עם תוכן פורנוגרפי, בלתי חוקי או המפר זכויות אדם.
    </p>
    <p>
        מצד שני, האתר עשוי להכיל קישורים לאתרי אינטרנט, פלטפורמות,
        פורומים, צ'אטים, בלוגים או רשתות חברתיות של צד שלישי. ל-{siteName}
        אין את האמצעים האנושיים ו/או הטכניים לדעת או לשלוט במידע ובתוכן
        המופיעים באתרי צד שלישי. לכן, בשום מקרה {siteName} לא תהיה אחראית
        לתוכן האתרים המקושרים ובשום נסיבות לא ניתן לראות בקישורים אלה
        ידיעה אפקטיבית של תוכן האתרים אליהם הם מקשרים.
    </p>
    <h3>16. הגנת מידע</h3>
    <p>
        כפי שנקבע ב-{privacyPolicyLink}, {siteName} מתחייבת להשתמש בנתוני
        המשתמש, לכבד את סודיותם ולהשתמש בהם בהתאם למטרת הטיפול, וכן
        לעמוד בחובתה לשמור עליהם ולהתאים את כל האמצעים למניעת שינוי,
        אובדן, טיפול או גישה בלתי מורשית בהתאם להוראות החקיקה הנוכחית
        בנוגע להגנת מידע אישי.
    </p>
    <p>
        האתר משלב אמצעי הגנה מתאימים ומשתמש בטכנולוגיה בתקן תעשייתי
        לשיפור האבטחה, השלמות, הדיוק וההגנה על המידע האישי שנאסף,
        וקבע אמצעי זהירות סבירים להגנה על מידע זה מפני אובדן או שימוש
        לרעה אפשריים. כללי הגנת המידע והאבטחה שלו נבדקים ומשופרים
        תקופתית לפי הצורך, והוא שואף להבטיח שרק אנשים מורשים יוכלו
        לגשת למידע שסיפק המשתמש.
    </p>
    <p>
        למידע נוסף על הניהול והטיפול שמבצעת {siteName} בנתונים שלכם,
        אנא קראו את {privacyPolicyLink} ואת {cookiesPolicyLink} שלנו.
    </p>
    <h3>17. תוקף ושינויים</h3>
    <p>
        תנאי שימוש אלה יהיו בתוקף כל עוד הם חשופים למשתמשים, כך שברגע
        שהם משתנים או מתעדכנים באופן מלא או חלקי, תנאים אלה יפסיקו
        להיות בתוקף, והתנאים החדשים יהיו אלה שימשיכו להסדיר את השימוש באתר.
    </p>
    <p>
        {siteName} שומרת לעצמה את הזכות לבדוק, לשנות או לעדכן את תנאי
        השימוש האלה בכל עת. במקרה של שינוי בתנאי שימוש אלה מכל סיבה
        שהיא, {siteName} תודיע למשתמשים בדף הבית של האתר על נסיבה זו
        כך שהם יהיו מיודעים כראוי ויוכלו להתייעץ בשינויים, בתיקונים
        או בעדכונים של תנאי השימוש הנוכחיים לשביעות רצונם.
    </p>
    <h3>18. כללי</h3>
    <p>
        בשום מקרה ותחת שום נסיבות לא ניתן להבין את חוסר המימוש של
        זכויותיה על ידי {siteName} כוויתור עליהן.
    </p>
    <p>
        הכותרות הכלולות בתנאים אלה הן אינדיקטיביות או אינפורמטיביות
        בלבד, כך שהן אינן משפיעות, מגדירות או מרחיבות את פרשנותן.
    </p>
    <p>
        במקרה שאחד מהסעיפים הכלולים בתנאים אלה יוכרז כבטל, פוגעני
        או בלתי ניתן לאכיפה, באופן מלא או חלקי, על ידי גוף שיפוטי
        או מנהלי, הצהרה זו תשפיע באופן פרטני על הסעיף הנדון, ותיחשב
        כאילו לא נכללה מבלי שהצהרת הבטלות, הפגיעה או אי-היישומיות
        תורחב בשום נסיבות לשאר התנאים, אשר ימשיכו להתקיים.
    </p>
    <p>
        תנאי שימוש אלה, כמו גם {privacyPolicyLink} ו-{cookiesPolicyLink}
        מוסדרים על פי התקנות הספרדיות הנוכחיות בכל עת.
    </p>
    <h3>19. שירות לקוחות</h3>
    <p>
        לכל הבהרה, תקרית או תלונה, תוכלו ליצור איתנו קשר דרך:<br />
        דוא"ל: {supportLink}<br />
        כתובת למשלוח דואר: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spain.
    </p>`
	},
	privacyPolicy: {
		lastUpdate: 'עודכן לאחרונה: 10 ביוני 2024',
		content: `
			<h3>1. צד אחראי ותיאור</h3>
			<h5>1.1. אחראי</h5>
			<p>האחראי לטיפול באתר זה הוא Remove Background S.L (להלן Remove Background או השירות), שכתובתו Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, ברצלונה, ספרד.</p>
			<p>מספר זיהוי פיסקלי: B56768260<br> דוא"ל: {supportLink}</p>

			<h5>1.2. תיאור</h5>
			<p>קבלת מדיניות הפרטיות של Remove Background (להלן "מדיניות הפרטיות") היא תנאי הכרחי לשימוש באתר האינטרנט שלנו ולאספקת השירות (להלן "השירות").<br>
				מדיניות פרטיות זו מסדירה את איסוף, טיפול ושימוש במידע האישי והלא-אישי שלך כמשתמש ב-Remove Background, החל מתאריך התוקף המופיע בכותרת.<br>
				לצורך עיבוד המידע האישי שלך, Remove Background מציית לחקיקה המקומית והאירופית העדכנית, וכן לתקנות היישום שלה.</p>

			<h3>2. מידע שנאסף</h3>
			<p>הגישה לאתר האינטרנט שלנו יכולה להתבצע ללא צורך במסירת מידע כלשהו, אך כדי להירשם ו/או להתקשר בתוכניות שלנו תצטרך לספק לנו מידע אישי מסוים. המידע (אישי או לא אישי) שנאסף על ידי השירות עשוי להשתנות בהתאם לכך.<br>
				המידע האישי והלא אישי שנאסף על ידי השירות יגיע אלינו בשלוש דרכים: 1) זה שנאסף אוטומטית 2) זה שאתה מספק לנו מרצון 3) זה שמסופק על ידי צדדים שלישיים.</p>

			<h5>2.1. המידע שנאסף אוטומטית</h5>
			<p>מידע זה יכלול:</p>
			<ul>
				<li>המידע שנאסף באמצעות קובצי cookie או מנגנונים דומים המאוחסנים במכשיר שלך, תמיד בהסכמתך או בהתאם לבסיסים משפטיים אחרים. בדוק את מדיניות ה-Cookies שלנו למידע נוסף.</li>
				<li>כתובת ה-IP ממנה מתבצע החיבור, סוג המכשיר ומאפייניו, גרסת מערכת ההפעלה, סוג הדפדפן, השפה, התאריך, המדינה, שעת הבקשה, כתובת ה-URL ממנה אתה מגיע, כתובת ה-URL אליה אתה הולך או הרשת הסלולרית בה נעשה שימוש, בין היתר.</li>
				<li>נתוני שימוש בשירות ושגיאות אפשריות שזוהו במהלך השימוש בו.</li>
				<li>בנוסף, Remove Background משתמש ב-Google Analytics, שירות אנליטי המסופק על ידי Google, LLC. שמושבה בארצות הברית עם מטה ב-1600 Amphitheater Parkway, Mountain View, California 94043. לצורך אספקת שירותים אלה, הם משתמשים בקובצי cookie האוספים מידע, כולל כתובת ה-IP של המשתמש, אשר יועבר, יעובד ויאוחסן על ידי Google בתנאים שנקבעו באתר www.google.com. כולל העברה אפשרית של מידע זה לצדדים שלישיים מסיבות של דרישה חוקית או כאשר צדדים שלישיים אלה מעבדים את המידע בשם Google.</li>
			</ul>
			<p>בכל מקרה, תוכל להשבית את קובצי ה-cookie של Google Analytics <a href="{externalLink: disableGoogleAnalyticsLink}">כאן</a>.</p>

			<h5>2.2. המידע שאתה מספק מרצון</h5>
			<p>מידע זה יכלול:</p>
			<ul>
				<li>כל הנתונים הם חובה.</li>
				<li>המידע הנדרש על ידי Remove Background להשלמת הרישום שלך באתר: שם ושם משפחה, כתובת ודוא"ל, בין היתר.</li>
				<li>כל הנתונים הם חובה.</li>
				<li>המידע, אישי או לא, להשלמת ההתקשרות בשירות כגון כתובת הדוא"ל שלך ומספר כרטיס האשראי או הדביט שלך.</li>
				<li>המידע, אישי או לא, שההודעות שנשלחות דרך ערוצי הקשר או חוות הדעת שנקבעו בשירות עשויות להכיל, לדוגמה שמך והדוא"ל שלך.</li>
			</ul>

			<h5>2.3. המידע המסופק על ידי צדדים שלישיים</h5>
			<p>מידע זה יכלול:</p>
			<ul>
				<li>המידע המסופק על ידי מערכות תשלום או מעבדי כרטיסי אשראי, כגון זמן הרכישה או סכומה.</li>
			</ul>

			<h3>3. זכויות ומטרות</h3>
			<p>אנו מודיעים לך שמילוי הטפסים הוא וולונטרי. עם זאת, אם לא תמלא את השדות הנדרשים (בדרך כלל מסומנים בכוכבית), השימוש בחלק מהפונקציות של השירות לא יהיה אפשרי או יהיה מוגבל.<br>
				הנתונים האישיים שאתה מספק לנו יוכנסו ויעובדו ברישום פעילויות הטיפול של Remove Background במטרה לטפל בבקשותיך, לספק את השירות המבוקש ולעדכן אותך בנושאים הקשורים לפעילות החברה ושירותיה.<br>
				אתה יכול לממש בכל עת את זכויות הגישה, תיקון, מחיקה, הגבלת הטיפול, התנגדות וניידות הנתונים האישיים שלך באמצעות דוא"ל לכתובת: {supportLink} או לכתובת הדואר: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, ברצלונה, ספרד.<br>
				בשני המקרים, עליך להזדהות בשמך ושם משפחתך, וכן להציג העתק של תעודת הזהות שלך, במידת הצורך.<br>
				במקרה שנתת הסכמה למטרה מסוימת, יש לך זכות לבטל את ההסכמה בכל עת, מבלי שהדבר ישפיע על חוקיות הטיפול המבוסס על ההסכמה לפני ביטולה.<br>
				בנוסף, אם אתה סבור שיש בעיה באופן שבו Remove Background מטפל בנתונים שלך, אתה יכול להפנות את תלונותיך לרשות הגנת המידע המתאימה, כאשר הסוכנות הספרדית להגנת מידע היא הגוף המוסמך במקרה של ספרד.</p>

			<h3>4. גיל</h3>
			<p>בנוגע לשימוש בשירות המקוון, אתה מצהיר כי אתה בגיר וכי יש לך את היכולת המשפטית הנדרשת להיות מחויב להסכם זה ולהשתמש באתר בהתאם לתנאיו והתניותיו, אותם אתה מבין ומאשר במלואם.<br>
				אתה מצהיר כי כל המידע שאתה מספק לצורך גישה לשירות, לפני ובמהלך השימוש בו, הוא אמיתי, שלם ומדויק.</p>

			<h3>5. שימוש בנתונים</h3>
			<p>Remove Background ישתמש בנתונים שנאספו כדי:</p>
			<ul>
				<li>לנהל ולעדכן את השירות (הבסיס המשפטי הוא האינטרס הלגיטימי שלנו בתחזוקת השירות ושמירתו מעודכן ובמצב טוב).</li>
				<li>לטפל בשאלות שאתה מעלה (הבסיס המשפטי הוא האינטרס הלגיטימי שלנו בטיפול בבקשות וספקות של המשתמשים שלנו).</li>
				<li>לעבד את התשלומים שאתה מבצע (החוזה הוא הבסיס המשפטי).</li>
				<li>לספק את השירות שהוזמן (החוזה הוא הבסיס המשפטי).</li>
				<li>לשמור על אבטחת השירות, לחקור פעילויות בלתי חוקיות, לאכוף את התנאים וההגבלות שלנו ולסייע לכוחות הביטחון במסגרת חקירותיהם האפשריות (הבסיס המשפטי הוא האינטרס הלגיטימי שלנו בהבטחת ושמירת אבטחת השירות ומשתמשיו).</li>
			</ul>
			<p>Remove Background אינו משתמש בהחלטות אוטומטיות, אך יכול ליצור פרופילי משתמש בסיסיים, כאשר הבסיס המשפטי הוא האינטרס הלגיטימי שלנו למטרות מסחריות ומתן הצעות מותאמות אישית.<br>
				כמו כן, Remove Background עשוי להשתמש במידע משתמשים בצורת נתונים מצטברים ואנונימיים כדי להציג אותם לצדדים שלישיים. הוא עשוי גם לשתף סטטיסטיקות ומידע דמוגרפי על משתמשים והשימוש שלהם בשירות עם צדדים שלישיים. אך אף אחד מאלה לא יאפשר לצדדים שלישיים אלה לזהות אותך אישית.</p>

			<h5>5.1. בדוא"ל וטפסי קשר</h5>
			<p>האתר כולל הצפנת SSL המאפשרת למשתמש לשלוח את הנתונים האישיים שלו באופן מאובטח באמצעות טפסי קשר סטנדרטיים.<br>
				הנתונים האישיים שנאספים יהיו כפופים לעיבוד אוטומטי ויוכנסו לקבצים המתאימים של רישום פעילויות העיבוד ושל Remove Background הוא הבעלים.</p>
			<p>במובן זה:</p>
			<ul>
				<li>נקבל את כתובת ה-IP שלך, אשר תשמש לאימות מקור ההודעה כדי להציע לך המלצות מתאימות (למשל, להציג את המידע בשפה הנכונה) ולזהות אי-סדירויות אפשריות (למשל, ניסיונות אפשריים לתקיפת סייבר על השירות), וכן נתונים הקשורים לספק האינטרנט שלך.</li>
				<li>כמו כן, אתה יכול לספק לנו את הנתונים שלך בטלפון, בדוא"ל ובאמצעי תקשורת אחרים שצוינו.</li>
			</ul>
			<p>בנוגע לאמצעי התשלום בהם נעשה שימוש:</p>
			<ul>
				<li>ספקי שירותי התשלום שלנו לתשלום עבור אספקת השירותים שלנו הם כרטיס אשראי או דביט. בשום שלב לא תהיה לשירות או לצוות שלו גישה לפרטים הבנקאיים (למשל, מספר כרטיס האשראי) שהמשתמש כלקוח יספק לאותם צדדים שלישיים.</li>
			</ul>

			<h3>6. שמירת נתונים</h3>
			<p>להלן מצוין למשך כמה זמן נשמרים הנתונים המעובדים על ידי השירות:</p>
			<ul>
				<li>הנתונים המפורטים יישמרו ללא תקופת מחיקה.</li>
				<li>
					נתוני לקוחות יישמרו למינימום הנדרש, ועשויים להישמר עד:
					<ul>
						<li>5 שנים, בהתאם לסעיף 1964 של הקוד האזרחי (פעולות אישיות ללא תקופה מיוחדת).</li>
						<li>6 שנים, בהתאם לסעיף 30 של הקוד המסחרי (ספרי חשבונות או חשבוניות, לדוגמה).</li>
					</ul>
				</li>
				<li>נתוני משתמש יישמרו לתקופה מקסימלית של 12 חודשים כדי לטפל בבקשותיהם.</li>
			</ul>

			<h3>7. נתונים המשותפים עם צדדים שלישיים</h3>
			<p>ישנם צדדים שלישיים המנהלים חלק מהשירות.<br>
				Remove Background דורש מהם לציית למדיניות פרטיות זו ככל שהיא חלה, בנוסף למדיניות משלהם. עם זאת, Remove Background לא יהיה אחראי לציות למדיניות האמורה.<br>
				בנסיבות מסוימות, Remove Background עשוי לשתף, להשתמש או לשמור עם צדדים שלישיים כל מידע אישי שנאסף:</p>
			<ul>
				<li>לספק את השירות:</li>
			</ul>
			<p>ספקי שירות המבצעים פונקציות בשמנו, כגון שירותי תשלום, אירוח אתרים, ניתוח עסקי, שירות לקוחות או שיווק באינטרנט. ספקי שירות אלה עשויים לאסוף ולקבל גישה למידע הנחוץ לביצוע תפקידיהם, אך אינם רשאים לשתף או להשתמש במידע למטרה אחרת כלשהי.</p>
			<ul>
				<li>לשתף פעולה עם הרשויות המוסמכות:</li>
			</ul>
			<p>אם אנו מאמינים שזה סביר הכרחי לספק כל חוק, הליך משפטי או אינטרס לגיטימי. בכל מקרה, נספק רק את המידע הנדרש במפורש.</p>

			<h3>8. אמצעי אבטחה</h3>
			<p>Remove Background מאמץ את כל האמצעים הטכניים והארגוניים הנדרשים להגנה על אבטחת ושלמות המידע האישי והלא אישי שנאסף. הן נגד גישה בלתי מורשית והן נגד שינוי, אובדן או הרס מקריים.<br>
				בכל מקרה, Remove Background אינו יכול להבטיח את האבטחה המוחלטת של המידע שנאסף, לכן עליך לשתף פעולה ולהשתמש בשכל ישר לגבי המידע המשותף בכל עת.<br>
				אתה מבין ומאשר כי, גם לאחר המחיקה, מידע אישי ולא אישי עשוי להישאר גלוי במטמון או אם משתמשים אחרים העתיקו או אחסנו אותו.</p>

			<h3>9. שינויים במדיניות הפרטיות</h3>
			<p>אנו עשויים לעדכן מדיניות פרטיות זו בעתיד. נודיע לך על השינויים על ידי שליחת הודעה לכתובת הדוא"ל שסיפקת ו/או על ידי הצבת הודעה במקום בולט באתר האינטרנט שלנו.</p>

			<h3>10. יצירת קשר</h3>
			<p>אם יש לך שאלות לגבי מדיניות פרטיות זו, צור איתנו קשר ב:</p>
			<p>דוא"ל: {supportLink}<br>
				כתובת: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, ברצלונה, ספרד.</p>
		`
	},
	gdpr: {
		lastUpdate: 'עודכן לאחרונה: 10 ביוני 2024',
		content: `
			<h3>1. מי אחראי ואיך ליצור קשר?</h3>
			<p>בעל השליטה באתר זה הוא Remove Background S.L שכתובתו Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, ברצלונה, ספרד.</p>
			<p>ניתן ליצור קשר באמצעות דוא"ל ב-{supportLink}.</p>

			<h3>2. אילו נתונים נאספים?</h3>
			<p>
				אנו אוספים נתונים באופן אוטומטי באמצעות העוגיות שאנו טוענים במכשיר שלך, כולל אנליטיקס.
				אנו גם אוספים את כתובת ה-IP ממנה מתבצע החיבור, סוג המכשיר ומאפייניו,
				גרסת מערכת ההפעלה, סוג הדפדפן, השפה, התאריך, המדינה, זמן הבקשה,
				כתובת ה-URL ממנה הגעת, כתובת ה-URL אליה אתה הולך או הרשת הסלולרית בה נעשה שימוש, ועוד.<br>
				באופן וולונטרי המשתמש מספק לנו מידע מסוים כמו שמו ושם משפחתו, דוא"ל או מידע בנקאי
				כדי שנוכל ליצור קשר, להירשם לשירות או לרכוש מנוי.
			</p>

			<h3>3. למה משמשים הנתונים שנאספו?</h3>
			<p>
				השירות ישתמש בנתונים שנאספו, בין היתר, לניהול ועדכון השירות, מענה לבקשותיך,
				שליחת הניוזלטר שלנו והצעות קידום מכירות בדוא"ל, ניהול הרישום שלך בפלטפורמה, ניהול ואספקת
				השירותים הקשורים למנוי שלך, עיבוד התשלומים שאתה מבצע והנפקת חשבוניות מתאימות,
				שמירה על אבטחת השירות, חקירת פעילויות בלתי חוקיות, אכיפת התנאים וההגבלות שלנו ו
				סיוע לכוחות הביטחון במסגרת חקירותיהם האפשריות.
			</p>

			<h3>4. כמה זמן הם נשמרים?</h3>
			<ul>
				<li>הנתונים המפורטים יישמרו ללא תקופת מחיקה.</li>
				<li>
					נתוני לקוחות יישמרו למינימום הנדרש, ועשויים להישמר עד:
					<ul>
						<li>5 שנים, בהתאם לסעיף 1964 של הקוד האזרחי (תביעות אישיות ללא תקופה מיוחדת).</li>
						<li>6 שנים, בהתאם לסעיף 30 של הקוד המסחרי (ספרי חשבונות או חשבונית, לדוגמה).</li>
					</ul>
				</li>
				<li>נתוני משתמש יישמרו לתקופה מקסימלית של 12 חודשים כדי לטפל בבקשותיהם.</li>
				<li>נתוני משתמש שהועלו על ידי השירות לדפים ופרופילים ברשתות חברתיות יישמרו מרגע שהמשתמש נותן את הסכמתו ועד שיבטל אותה.</li>
			</ul>

			<h3>5. מהן זכויותיך כמשתמש?</h3>

			<p>
				זכות גישה: לנפגע תהיה הזכות לקבל אישור מבעל השליטה במידע האם
				מעובד או לא מעובד מידע אישי הנוגע אליו.
			</p>
			<p>
				זכות תיקון: לנפגע תהיה הזכות לקבל, ללא עיכוב בלתי סביר, מבעל השליטה במידע
				תיקון של מידע אישי שאינו מדויק ושמשפיע עליו ישירות. כמו כן, למעוניין תהיה
				הזכות להשלים מידע אישי חסר, כולל באמצעות הצהרה נוספת.
			</p>
			<p>
				זכות מחיקה: זוהי זכותו של הנפגע לקבל, ללא עיכוב בלתי סביר, מבעל השליטה במידע את מחיקת
				המידע האישי הנוגע אליו.
			</p>
			<p>
				זכות להגביל עיבוד נתונים: מתבטאת בהשגת הגבלה על עיבוד הנתונים שלך על ידי האחראי,
				אם כי מימושה יש לו שני היבטים: 1) כאשר אתה מערער על דיוק המידע האישי שלך, במשך תקופה המאפשרת
				לאחראי לאמת זאת ו-2) כאשר התנגדת לעיבוד המידע האישי שלך שהאחראי
				מבצע על בסיס אינטרס לגיטימי או משימה של אינטרס ציבורי, בזמן שהאחראי מוודא האם סיבות אלו
				גוברות על שלך.
			</p>
			<p>
				זכות לניוד נתונים: זוהי זכותו של הנפגע לקבל את המידע האישי הנוגע אליו,
				שהוא סיפק לבעל שליטה במידע, בפורמט מובנה, לשימוש נפוץ וקריאה ממוכנת, ו
				להעביר אותם לבעל שליטה אחר מבלי שימנע ממנו זאת בעל השליטה שלו נמסרו הנתונים.
			</p>
			<p>
				במובן זה, למעוניין תהיה הזכות שהמידע האישי יועבר ישירות מבעל שליטה
				לבעל שליטה כאשר הדבר אפשרי טכנית.
			</p>

			<h3>6. כיצד תוכל לממש את זכויותיך?</h3>

			<p>
				תוכל לממש את זכויות המידע האישי שלך בכל עת על ידי שליחת דוא"ל ל: {supportLink} או לכתובת הדואר:
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, ברצלונה, ספרד. בשני המקרים, עליך להזדהות בשמך ושם משפחתך,
				וכן לצרף העתק של תעודת הזהות שלך או תעודה מזהה לאומית, במידת הצורך.<br>
				בנוסף, אם אתה סבור שיש בעיה באופן שבו Remove Background מטפל בנתונים שלך, תוכל להפנות את תלונותיך
				ל<a href="{knowYourRightsLink}">רשות הגנת המידע</a> המתאימה, כאשר <a href="{aepdLink}">הסוכנות הספרדית להגנת מידע</a>
				היא הרשות המוסמכת במקרה של ספרד.
			</p>

			<h3>7. האם ננקטים אמצעי אבטחה?</h3>
			<p>
				השירות נוקט בכל האמצעים הטכניים והארגוניים הנדרשים להגנה על אבטחת ושלמות המידע האישי
				והלא-אישי שנאסף. הן כנגד גישה בלתי מורשית והן כנגד שינוי, אובדן או השמדה מקריים.<br>
				בכל מקרה, השירות אינו יכול להבטיח את האבטחה המוחלטת של המידע שנאסף, לכן עליך לשתף פעולה ו
				להשתמש בשכל הישר בכל עת בנוגע למידע המשותף.<br>
				אתה מבין ומאשר כי, גם לאחר המחיקה, מידע אישי ולא-אישי עשוי להישאר גלוי במטמון או
				אם הועתק או אוחסן על ידי משתמשים אחרים.
			</p>

			<h3>8. האם יש העברות של מידע אישי או העברות בינלאומיות?</h3>

			<p>
				איננו מבצעים העברות נתונים או העברות בינלאומיות. עם זאת, ישנם צדדים שלישיים המנהלים חלק מהשירות
				שאנו דורשים מהם לציית למדיניות הפרטיות שלנו ככל שהיא חלה עליהם ושיש להם את שלהם.
				צדדים שלישיים אלה הם ספקי שירות המבצעים פונקציות בשמנו, כגון אירוח אתרים,
				ניטור אנליטיקס, או פיתוח אתרים.<br>
				כמו כן, אם אנו מאמינים שזה סביר הכרחי לספק כל חוק, הליך משפטי או אינטרס לגיטימי.
				בכל מקרה, נספק רק את המידע הנדרש במדויק.
			</p>

		`
	},
	cookiesPolicy: {
		lastUpdate: 'עודכן לאחרונה: 21 ביוני 2024',
		content: `
			<h3>תקציר</h3>
			<ul>
			    <li>עוגיות בשימוש: <strong>עצמיות וצד שלישי</strong></li>
			    <li>האם הן משמשות להשגת סטטיסטיקות? <strong>כן, בהתבסס על האינטרס הלגיטימי שלנו בניהול טוב יותר של השירות.</strong></li>
			    <li>שירותי צד שלישי המתקינים עוגיות דרך אתר זה: <strong>Google, Google Analytics, Cloudflare, ו-Stripe.</strong></li>
			</ul>

			<h3>כיצד להגדיר ולהשבית עוגיות</h3>
			<p>
			    תוכל לאפשר, לחסום או למחוק את העוגיות המותקנות במכשיר שלך מדפדפן האינטרנט שלך. אם לא תאפשר התקנת עוגיות במכשיר שלך,
			    חוויית הגלישה עלולה להיפגע. להלן תוכל למצוא כיצד להגדיר עוגיות בכל דפדפן:
			</p>
			<ul>
			    <li><a href="{externalLink: edgeCookies}">Edge</a></li>
			    <li><a href="{externalLink: chromeCookies}">Google Chrome</a></li>
			    <li><a href="{externalLink: googleAndroidCookies}">Google Android</a></li>
			    <li><a href="{externalLink: internetExplorer8Cookies}">Internet Explorer 8</a></li>
			    <li><a href="{externalLink: internetExplorer9Cookies}">Internet Explorer 9</a></li>
			    <li><a href="{externalLink: internetExplorer11Cookies}">Internet Explorer 11</a></li>
			    <li><a href="{externalLink: firefoxCookies}">Mozilla Firefox</a></li>
			    <li><a href="{externalLink: operaCookies}">Opera</a></li>
			    <li><a href="{externalLink: safariCookies}">Safari</a></li>
			    <li><a href="{externalLink: safariMobileCookies}">Safari Mobile</a></li>
			</ul>

			<h3>1. סוגים ושימושים</h3>
			<p>השירות משתמש בעוגיות עצמיות ושל צד שלישי לשיפור הגלישה, אספקת השירות, והשגת סטטיסטיקות על השימוש באתר.</p>

			<h3>2. מהי עוגייה ולמה היא משמשת?</h3>
			<p>
			    עוגייה היא קובץ טקסט הנשלח למחשב, לדפדפן הנייד או הטאבלט שלך ומשמש לאחסון ואחזור מידע אודות
			    הגלישה שבוצעה. לדוגמה, לזכור את שם המשתמש והסיסמה שלך או את העדפות הפרופיל שלך.
			</p>

			<h3>3. אילו סוגי עוגיות קיימים?</h3>
			<p>בהתאם למי שמנהל אותן:</p>
			<ul>
			    <li>עוגיות עצמיות; הן נשלחות לדפדפן שלך מהציוד או דומיין האינטרנט שלנו.</li>
			    <li>עוגיות צד שלישי; הן נשלחות לדפדפן שלך מציוד או דומיינים שאיננו מנהלים ישירות, אלא על ידי צד שלישי כמו Google.</li>
			</ul>
			<p>בהתבסס על משך הזמן שהן נשארות פעילות, ישנן:</p>
			<ul>
			    <li>עוגיות מושב; הן נשארות בקובץ העוגיות של הדפדפן שלך עד שתעזוב את האתר, כך שאף אחת לא נשארת במכשיר שלך.</li>
			    <li>עוגיות קבועות; הן נשארות במכשיר שלך והאתר שלנו קורא אותן בכל פעם שאתה מבצע ביקור חדש. עוגיות אלה מפסיקות לפעול לאחר תאריך מסוים.</li>
			</ul>
			<p>לבסוף, בהתאם למטרתן, יש לנו:</p>
			<ul>
			    <li>עוגיות טכניות; הן משפרות את הגלישה והתפקוד התקין של האתר.</li>
			    <li>עוגיות התאמה אישית; הן מאפשרות גישה לשירות עם מאפיינים מוגדרים מראש בהתבסס על סדרה של קריטריונים.</li>
			    <li>עוגיות אנליטיקס; הן מאפשרות מדידה וניתוח סטטיסטי של השימוש בשירות המסופק.</li>
			</ul>
			<p>רשימת עוגיות צד שלישי המשמשות את <strong>remove-background.com</strong></p>
			<ul>
			    <li>
			        <a href="{externalLink: googleCookiesPolicy}">Google</a>: העוגיות שלהם (NID או CONSENT) מאפשרות התאמה אישית של אופן הופעת המודעות מחוץ ל-Google או אחסון מידע
			        כמו השפה המועדפת בהצגת תוצאות חיפוש.<br><a href="{externalLink: googleCookieTypes}">מידע נוסף</a> על סוגי העוגיות ש-Google משתמשת בהן בשירותיה השונים.
			    </li>
			    <li>
			        <a href="{externalLink: googleAnalyticsCookies}">Google Analytics</a>: העוגיות שלהם (כמו _ga) מאפשרות לספור כמה פעמים משתמש מבקר באתר, איך, מתי ומאיפה.<br>
			        בכל מקרה, תוכל להשבית את עוגיות Google Analytics מ<a href="{externalLink: disableGoogleAnalytics}">כאן</a>.
			    </li>
			    <li>Cloudflare: כדי ללמוד על מדיניות העוגיות והשימוש של Cloudflare, לחץ על <a href="{externalLink: cloudflareCookiesPolicy}">קישור זה</a>.</li>
			    <li>Stripe: מצא מידע <a href="{externalLink: stripeCookiesPolicy}">כאן</a> על מדיניות העוגיות והשימוש של Stripe.</li>
			</ul>
			
		`
	}
};
